import styles from "@styles/pages/cdp/filters.module.scss";
import { useEffect, useState } from "react";

import { Button, Checkbox } from "@components";
import classNames from "classnames/bind";
import TextForm from "../types/TextForm";
const css = classNames.bind(styles);

export const CustomerDocForm = ({ data, variable, onChange }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [value, setValue] = useState("");

  const freshData = {
    name: variable.label,
    type: "c.doc",
    operand: "like",
    values: data?.values || [],
    active: data?.active || false,
  };

  const input_configs = {
    mask: "999.999.999-99",
    placeholder: "000.000.000-00",
  };

  useEffect(() => {
    if (freshData.active) setCollapsed(true);
  }, [freshData.active]);

  return (
    <li className={css({ filter: true, collapsed })} key={variable.label}>
      <div
        className={styles.header}
        onClick={() =>
          !freshData.active && onChange({ ...freshData, active: true })
        }
      >
        <div className="d-flex align-center">
          <Checkbox
            design="two"
            label={variable.label}
            checked={data?.active}
            onChange={(value) => onChange({ ...freshData, active: value })}
          />
          {freshData?.active && <div className={styles.dot} />}
        </div>
        <div className="d-flex align-center">
          <div
            className={styles.collapse}
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? (
              <i className="fas fa-minus" />
            ) : (
              <i className="fas fa-plus" />
            )}
          </div>
        </div>
      </div>

      {collapsed && (
        <div className={styles.content}>
          <div className="d-flex align-center">
            <TextForm
              text={value}
              onChange={(newData) => setValue(newData)}
              input_configs={input_configs}
            />
            <Button
              design="default-icon-3"
              className="ml-10"
              disabled={!value || value.length < 13}
              onClick={() => {
                onChange({
                  ...freshData,
                  values: [...(freshData?.values || []), value],
                });
                setValue("");
              }}
            >
              <i className="far fa-plus" />
            </Button>
          </div>

          <ul className={styles.contains}>
            {freshData?.values?.map((value, index) => (
              <li className={styles.item} key={index}>
                <span>{value}</span>
                <div className={styles.remove}>
                  <i
                    className="fas fa-times"
                    onClick={() => {
                      onChange({
                        ...freshData,
                        values: freshData.values.filter((v) => v !== value),
                      });
                    }}
                  />
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </li>
  );
};
